import React from 'react'

import { Container, HeadingText, Inner, NumberText, Subheading } from './styles'

export interface HeadingProps {
  number?: number
  subheading?: string
  children: React.ReactNode
}

export const Heading = ({ number, subheading, children }: HeadingProps) => {
  return (
    <Container>
      <Inner>
        {number && <NumberText>{`${number}`.padStart(2, '0')}</NumberText>}
        <HeadingText>{children}</HeadingText>
        {subheading && <Subheading>{subheading}</Subheading>}
      </Inner>
    </Container>
  )
}
